import { BaseService } from '@myhealth-raccoon/services';

import { Customer } from 'src/services/customer/types.ts';
import { queryStringOrSessionStorage } from 'src/utils/queryStringOrSessionStorage';

class CustomerService extends BaseService {
    constructor() {
        super('api/customer', import.meta.env.VITE_CUSTOMER_API_URL);
    }

    private _token: string = queryStringOrSessionStorage('customer_jwt')!;

    get Authorization() {
        return this._token ? `Bearer ${this._token}` : undefined;
    }

    public set Token(jwt: string) {
        this._token = jwt;
        sessionStorage.setItem(`customer_token`, jwt);
    }

    public async GetById(id: number | string) {
        return await this.get<Customer>(`${id}`);
    }
}

export const customerService = new CustomerService();
